export default __webpack_public_path__ + "static/media/chef.b4a9f461.png";